exports.list = {
    path: '/laporan_po',
    name: 'laporan_po', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/laporan_po/List.vue"),
}